/*!
 * Video cards — porneste videoclipurile doar cat sunt vizibile pe ecran.
 *
 * Videoclipurile nu au atributul `autoplay`: redarea e controlata de aici, ca sa
 * nu consume banda si CPU cand sectiunea e sub fold sau cand tab-ul e in fundal.
 */
(function () {
  // Scriptul poate fi inclus de mai multe sectiuni pe aceeasi pagina.
  if (window.__videoCardsAutoplayInit) return;
  window.__videoCardsAutoplayInit = true;

  const VIDEO_SELECTOR = '.video-cards__video, .js-autoplay-in-view';
  const VISIBLE_RATIO = 0.25;
  // Cat de devreme incepe descarcarea, inainte ca respectivul card sa se vada.
  const WARMUP_MARGIN = '400px 0px';

  // Videoclipurile care au intrat in viewport; folosite la pauza pe tab ascuns.
  const playing = new Set();

  let warmupObserver = null;
  let playObserver = null;

  // Fisierele au `preload="none"`, ca sa nu se ceara nimic la incarcarea paginii.
  // Cardul care se apropie de ecran isi cere insa datele din timp: altfel redarea
  // porneste abia dupa ce cardul e deja vizibil, iar clipul stă pe posterul lui.
  function getWarmupObserver() {
    if (warmupObserver) return warmupObserver;

    warmupObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const video = entry.target;
          observer.unobserve(video);
          video.preload = 'auto';
          // `load()` ar da redarea inapoi la zero, deci doar pentru un clip
          // care inca n-a cerut nimic: cardul vizibil isi porneste singur fisierul.
          if (video.readyState === 0 && video.paused) video.load();
        });
      },
      { rootMargin: WARMUP_MARGIN }
    );

    return warmupObserver;
  }

  function getPlayObserver() {
    if (playObserver) return playObserver;

    playObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= VISIBLE_RATIO) {
            playing.add(video);
            if (!document.hidden) video.play().catch(() => {});
          } else {
            playing.delete(video);
            video.pause();
          }
        });
      },
      { threshold: [0, VISIBLE_RATIO] }
    );

    return playObserver;
  }

  function init(root) {
    // Preferintele utilizatorului au prioritate: fara redare automata daca a cerut
    // mai putina miscare sau navigheaza cu economie de date.
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (reduceMotion || saveData) return;

    const videos = (root || document).querySelectorAll(VIDEO_SELECTOR);
    if (!videos.length) return;

    const warmup = getWarmupObserver();
    const play = getPlayObserver();
    videos.forEach((video) => {
      warmup.observe(video);
      play.observe(video);
    });
  }

  document.addEventListener('visibilitychange', () => {
    playing.forEach((video) => {
      if (document.hidden) {
        video.pause();
      } else {
        video.play().catch(() => {});
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor: blocul poate fi adaugat sau re-randat fara reload.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => init(event.target));
})();
